import {
  Input, SimpleChanges, OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {CompanyService} from "../../services/company-service/company-service";
import {OrderBagItemDetailVM} from "../../models/OrderBagItemVM.model";
import {ServantService} from "../../services/servant-service/servant-service";
import {TestService} from "../../services/test-services/test.service";
import {CompanyVM} from "../../models/CompanyVM.model";
import {InvoiceInfoService} from "../../services/invoice-info-service/invoice-info.service";
import {OrderBagService} from "../../services/orderbag/orderbag.service";


@Component({

  selector: 'rw-test-services',  // <home></home>
  providers: [TestService],
  styles: [require('./test-services.component.css')],
  template: require('./test-services.component.html')

})
export class TestServicesComponent implements OnInit, OnChanges {


  localInvoiceId: number = null;
  keyUrl:string = "";
  result:string;
  token:string;
  transGateId:string;

  constructor(private companyService: CompanyService,
              private testService: TestService
  ) {
  }

  public ngOnInit() {

    this.companyService.getCompanyInfo().subscribe((c:CompanyVM) => {
        this.keyUrl = c.keyUrl;
    })

  }

  ngOnChanges(changes: SimpleChanges): void {
    let parent = this;
  }

  makeTestPaymentAP(){
    this.testService.makeTestOnlinePaymentAP(this.localInvoiceId,this.keyUrl).subscribe(result => {
      if(result && result.token)
        this.token = result.token;
      debugger;
    })
  }

  goToAP() {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    // form.setAttribute('action', 'https://asan.shaparak.ir');
    form.setAttribute('action', 'https://consult.planovin.com/#/testReturnUrl');
    form.setAttribute('target', '_self');

    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('name', 'RefId');
    hiddenField.setAttribute('value', this.token);
    form.appendChild(hiddenField);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  verifyPaymentAP(){
    this.testService.verifyTestOnlinePaymentAP(this.localInvoiceId,this.keyUrl).subscribe(result => {
      this.result = result;
      debugger;
    })
  }
  getTransDetailAP(){
    this.testService.getTransDetailAP(this.localInvoiceId,this.keyUrl).subscribe(result => {
      this.transGateId = result;
      debugger;
    })
  }
  removeQuote(){
    this.token = this.token.replace(/"/g, '');
  }

  goToSEP() {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', 'https://sep.shaparak.ir/onlinepg/onlinepg');
    // form.setAttribute('action', 'https://consult.planovin.com/#/testReturnUrl');
    form.setAttribute('target', '_self');

    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('name', 'Token');
    hiddenField.setAttribute('value', this.token);
    form.appendChild(hiddenField);

    const hiddenField2 = document.createElement("input");
    hiddenField2.setAttribute("name", "GetMethod");
    hiddenField2.setAttribute("value", "true");
    form.appendChild(hiddenField2);


    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  makeTestPaymentSEP(){
    this.testService.makeTestOnlinePaymentSEP(this.localInvoiceId,this.keyUrl).subscribe(result => {
      if(result && result.refId)
        this.token = result.refId;
      debugger;
    })
  }

}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/test-services/test-services.component.ts